import React from 'react'

interface DropdownIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const DropdownIcon: React.FC<DropdownIconProps> = ({
  color = '#000',
  gradient,
  width = 24,
  height = 10,
  alt = 'Dropdown icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 24 10'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M1.25 1.25V8h21.5V1.25H1.25zM1 0a1 1 0 00-1 1v7.25a1 1 0 001 1h22a1 1 0 001-1V1a1 1 0 00-1-1H1z'
        clipRule='evenodd'
      />
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M18.817 6.067a.625.625 0 01-.884 0l-2-2a.625.625 0 11.884-.884l1.558 1.558 1.558-1.558a.625.625 0 11.884.884l-2 2z'
        clipRule='evenodd'
      />
    </svg>
  )
}

export default DropdownIcon
